// ArenaUserDashboard.js
import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import {
  MapPin,
  User,
  Clock,
  MapPin as LocationIcon,
  X,
  ChevronRight,
} from "react-feather";
import Header from "../../dasboard-component/Components/HeaderMain";
import ArenaGrid from "./ArenaGrid";
import SportSelection from "./SportSelection";
import FacilitySelection from "./FacilitySelection";
import SlotSelection from "./SlotSelection";
import BookingOptions from "./BookingOptions";
import MyBookings from "./MyBookings";
import ArenaProfile from "../../Admin/Arena/arenaProfile.jsx";
import UserProfile from "./UserProfile";
import styles from "./ArenaUserDashboard.module.css";
import AddressForm from "./ArenaMap_nearby";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import TextAds from "../../components/textAd.jsx";
import ImageVideoAds from "../../components/imageVideoAd.jsx";
import { useAuth } from "../../context/AuthContext";
import { toast } from "react-toastify";
import ConfirmationModal from "../../common/ConfirmationModal.jsx";

const ArenaUserDashboard = ({ preview, selectTheSlot }) => {
  const [userData, setUserData] = useState(null);
  const [selectedArena, setSelectedArena] = useState(null);
  const [selectedSport, setSelectedSport] = useState(null);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [selectedSlots, setSelectedSlots] = useState(null);
  const [bookingType, setBookingType] = useState(null);
  const [showMyBookings, setShowMyBookings] = useState(false);
  const [myBookings, setMyBookings] = useState([]);
  const [showArenaProfile, setShowArenaProfile] = useState(false); // New state for showing arena profile
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showUserProfile, setShowUserProfile] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const notificationsPanelRef = useRef(null);
  const [userCity, setUserCity] = useState("");
  const [availableCities, setAvailableCities] = useState([]);
  const [arenas, setArenas] = useState([]);

  const [facilities, setFacilities] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [adsSelected, setAdsSelected] = useState([]);
  const [currentAdIndexes, setCurrentAdIndexes] = useState({
    0: 0,
    1: 0,
    2: 0,
    3: 0,
  });

  const [selectedAd, setSelectedAd] = useState(null);
  const [ads, setAds] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedBookingForCancel, setSelectedBookingForCancel] =
    useState(null);
  const { user } = useAuth();

  useEffect(() => {}, [facilities]);
  const fetchFacilities = async (sportId) => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/user-dashboard/sport-facilities?sportId=${sportId}`
      );
      console.log(response.data);

      setFacilities(response.data);
    } catch (error) {
      console.error("Error fetching facilities:", error);
      setFacilities([]);
    } finally {
      console.log(facilities);
      setIsLoading(false);
    }
  };

  const handleSportSelect = (sport) => {
    setSelectedSport(sport);
    fetchFacilities(sport.id);
  };

  const fetchArenaSports = async (arenaId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/user-dashboard/arena-sports?arenaId=${arenaId}`
      );
      return { sports: response.data, error: null };
    } catch (error) {
      console.error("Error fetching arena sports:", error);
      if (error.response && error.response.status === 404) {
        return { sports: [], error: "No facility/sports found" };
      }
      return { sports: [], error: "An error occurred while fetching sports" };
    }
  };

  const handleArenaSelect = async (arena) => {
    const { sports, error } = await fetchArenaSports(arena.id);
    setSelectedArena({ ...arena, sports, error });
  };

  const handleViewDetails = (arena) => {
    setSelectedArena(arena);
    setShowArenaProfile(true);
  };

  const handleCloseProfile = () => {
    setShowArenaProfile(false);
  };

  async function fetchBookings() {
    try {
      const uid = user?.uid;
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/user-dashboard/user-bookings?userId=${uid}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch bookings");
      }
      const data = await response.json();
      setMyBookings(data);
    } catch (error) {
      console.error("Error fetching bookings:", error);
    }
  }

  useEffect(() => {
    const fetchedUserData = {
      name: user?.name,
      location: user?.location,
    };

    setUserData(fetchedUserData);

    const city = fetchedUserData.location?.split(",")[0]?.trim() || "";
    setUserCity(city);

    fetchAvailableCities();

    if (city) {
      fetchArenas(city);
    }

    fetchBookings();
  }, [user]);

  const fetchAvailableCities = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/user-dashboard/arenas-locations`
      );
      setAvailableCities(response.data);
    } catch (error) {
      console.error("Error fetching available cities:", error);
    }
  };

  const fetchArenas = async (city) => {
    if (city === "Select a city") {
      setArenas([]);
      return;
    } else {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/user-dashboard/arenas-available?city=${city}`
        );
        setArenas(response.data);
      } catch (error) {
        console.error("Error fetching arenas:", error);
      }
    }
  };

  const handleCityChange = (event) => {
    const newCity = event.target.value;
    setUserCity(newCity);
    fetchArenas(newCity);
  };

  //////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////

  useEffect(() => {
    // ... (previous useEffect code)

    setNotifications([
      {
        id: 1,
        type: "friendRequest",
        sender: { id: 101, name: "John Doe" },
        message: "Hi, I want to play that game with you!",
        matchDetails: {
          sport: "Football",
          arena: "Sports Complex A",
          date: "2024-08-10",
          time: "14:00-16:00",
        },
        timestamp: new Date("2024-08-01T10:00:00"),
      },
      {
        id: 2,
        type: "requestAccepted",
        accepter: { id: 102, name: "Jane Smith" },
        matchDetails: {
          sport: "Basketball",
          arena: "Fitness Center B",
          date: "2024-08-15",
          time: "10:00-11:00",
        },
        timestamp: new Date("2024-08-02T14:30:00"),
      },
      {
        id: 3,
        type: "arenaApproved",
        arenaName: "Your Arena Name",
        timestamp: new Date("2024-08-03T09:15:00"),
      },
    ]);

    const handleClickOutside = (event) => {
      if (
        notificationsPanelRef.current &&
        !notificationsPanelRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleAcceptRequest = (notificationId) => {
    // Here you would send the acceptance to your backend
    console.log(`Accepted friend request ${notificationId}`);
    // Update the local state to reflect the acceptance
    setNotifications(
      notifications.map((n) =>
        n.id === notificationId ? { ...n, status: "accepted" } : n
      )
    );
  };

  const handleRejectRequest = (notificationId) => {
    // Here you would send the rejection to your backend
    console.log(`Rejected friend request ${notificationId}`);
    // Update the local state to reflect the rejection
    setNotifications(
      notifications.map((n) =>
        n.id === notificationId ? { ...n, status: "rejected" } : n
      )
    );
  };

  const handleClearNotification = (notificationId) => {
    // Here you would send the clear request to your backend
    console.log(`Clearing notification ${notificationId}`);
    // Update the local state to remove the notification
    setNotifications(notifications.filter((n) => n.id !== notificationId));
  };

  const handleViewUserProfile = (user) => {
    setSelectedUser(user);
    setShowUserProfile(true);
  };

  const handleCloseUserProfile = () => {
    setShowUserProfile(false);
    setSelectedUser(null);
  };

  const formatTimestamp = (timestamp) => {
    const now = new Date();
    const diffInMinutes = Math.floor((now - timestamp) / (1000 * 60));
    if (diffInMinutes < 60) {
      return `${diffInMinutes}m ago`;
    } else if (diffInMinutes < 1440) {
      return `${Math.floor(diffInMinutes / 60)}h ago`;
    } else {
      return timestamp.toLocaleDateString();
    }
  };

  const handleSubmitReview = async (bookingId, rating, comment = "") => {
    console.log(
      `Submitted review for booking ${bookingId} with rating ${rating} and comment: "${comment}"`
    );

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/user-dashboard/submit-review`,
        {
          bookingId,
          rating,
          comment,
        }
      );

      if (response.data.success) {
        toast.success("Review submitted successfully!");
      }
    } catch (error) {
      console.error("Error submitting review:", error);
      toast.error("Failed to submit review. Please try again later.");
    }
    fetchBookings();
  };

  const handleCancelBooking = (booking) => {
    setSelectedBookingForCancel(booking);
    setShowConfirmModal(true);
  };

  const handleConfirmCancelBooking = async () => {
    if (!selectedBookingForCancel) return;

    try {
      // selectedBookingForCancel.id is already an array of booking IDs
      const bookingIds = Array.isArray(selectedBookingForCancel.id)
        ? selectedBookingForCancel.id
        : [selectedBookingForCancel.id];

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/user-dashboard/cancel-booking`,
        { bookingId: bookingIds }
      );

      if (response.data.success) {
        toast.success("Booking cancelled successfully!");
        fetchBookings();
        setShowConfirmModal(false);
        setSelectedBookingForCancel(null);
      }
    } catch (error) {
      console.error("Error cancelling booking:", error);
      console.error("Error response:", error.response?.data);
      toast.error("Error cancelling booking. Please try again.");
      setShowConfirmModal(false);
      setSelectedBookingForCancel(null);
    }
  };

  const handleCloseModal = () => {
    setShowConfirmModal(false);
    setSelectedBookingForCancel(null);
  };

  const handleBack = () => {
    if (bookingType) setBookingType(null);
    else if (selectedSlots) setSelectedSlots(null);
    else if (selectedFacility) setSelectedFacility(null);
    else if (selectedSport) setSelectedSport(null);
    else if (selectedArena) setSelectedArena(null);
  };

  const handleSlotSelect = (slots) => {
    setSelectedSlots(slots);
  };

  const handleBookingTypeSelect = (type, emails = []) => {
    setBookingType(type);

    const fixedMessage = "Hi, I want to play that game with you!";

    // Here you would typically send the booking information to your backend
    const bookingInfo = {
      arena: selectedArena,
      sport: selectedSport,
      facility: selectedFacility,
      slots: selectedSlots,
      bookingType: type,
      user: userData,
      totalPrice: selectedSlots.reduce((sum, slot) => sum + slot.price, 0),
      friendEmails: emails,
      friendMessage: type === "friend" ? fixedMessage : "", // Include the fixed message for friend requests
    };
    console.log("Booking information:", bookingInfo);

    // You would send this information to your backend here

    // Simulating an API call to send friend requests
    if (type === "friend" && emails.length > 0) {
      emails.forEach((email) => {
        console.log(
          `Sending friend request to ${email} with message: ${fixedMessage}`
        );
        // Here you would make an actual API call to send the friend request
      });
    }
  };

  const handleReturnToDashboard = () => {
    setSelectedArena(null);
    setSelectedSport(null);
    setSelectedFacility(null);
    setSelectedSlots(null);
    setBookingType(null);
  };

  const toggleMyBookings = () => {
    const newShowMyBookings = !showMyBookings;
    setShowMyBookings(newShowMyBookings);

    // Refresh bookings when opening My Bookings
    if (newShowMyBookings) {
      fetchBookings();
    }
  };

  useEffect(() => {
    if (preview) return;

    let isMounted = true;
    let timeoutId;

    const fetchAds = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/download-ad`
        );
        if (isMounted) setAds(response.data.ads);
      } catch (error) {
        console.error("Error fetching ads:", error);
      }

      if (isMounted) {
        timeoutId = setTimeout(fetchAds, 500);
      }
    };

    fetchAds();

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, [preview]);

  const handleClicks = async (e, ad) => {
    if (preview) {
      const id = e.currentTarget.dataset.id;

      if (
        (id === "ad-1" && preview === "text") ||
        (id === "ad-2" && preview === "image") ||
        (id === "ad-3" && preview === "video")
      ) {
        setSelectedAd(id);
        selectTheSlot(id);
      }
    }

    e.preventDefault();

    if (!ad || !ad.url) return;
    window.location.href = ad.url;
    ad.clicks = ad.clicks + 1;

    try {
      const jsonData = {
        clicks: ad.clicks,
        id: ad.ids,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/upload-clicks`,
        jsonData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.success) {
      } else {
        throw new Error(response.data.message || "Failed to upload clicks");
      }
    } catch (error) {
      console.error("Error uploading clicks:", error);
      toast.error("Failed to upload Clicks: " + error.message);
    }
  };

  const convertDate = (dateString) => {
    const dateObj = new Date(dateString);

    dateObj.setDate(dateObj.getDate());

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  useEffect(() => {
    const getCurrentAds = () => {
      const now = new Date();
      const isoDate = now.toISOString().slice(0, 10); // "2025-06-17"
      const current_date = `${isoDate}T00:00:00`;
      const current_time = now.toTimeString().split(" ")[0];

      const newAds = [];

      for (const ad of ads) {
        const isDateInRange =
          ad.start_date.split("T")[0] <= current_date.split("T")[0] &&
          convertDate(current_date) <= ad.end_date.split("T")[0];

        const datePart = convertDate(current_date);
        const currentTime = new Date(`${datePart}T${current_time}`);
        const startTime = new Date(`${datePart}T${ad.start_time}`);
        const endTime = new Date(`${datePart}T${ad.end_time}`);
        const isTimeInRange =
          startTime <= currentTime && currentTime <= endTime;

        const isTimeIterRemaining = ad.total_time > 0;

        if (
          isDateInRange &&
          isTimeInRange &&
          isTimeIterRemaining &&
          ad.slotPlace.split(" ")[0] === "arenaHomePage"
        ) {
          newAds.push(ad);
        }
      }

      if (JSON.stringify(adsSelected) !== JSON.stringify(newAds)) {
        const indexedAds = [];

        newAds.forEach((ad) => {
          const slotPlace = ad.slotPlace;
          const index = parseInt(slotPlace.trim().split(" ").pop(), 10);

          if (!isNaN(index)) {
            if (!indexedAds[index]) {
              indexedAds[index] = [];
            }
            indexedAds[index].push(ad);
          }
        });

        setAdsSelected(indexedAds);
      }
    };

    getCurrentAds();

    const interval = setInterval(() => {
      getCurrentAds();
    }, 1000);

    return () => clearInterval(interval);
  }, [ads]);

  const updateIterations = async (slot, i) => {
    if (!adsSelected[slot] || !adsSelected[slot][i]) return;

    try {
      const jsonData = {
        iterations: adsSelected[slot][i].iterations,
        total_time: adsSelected[slot][i].total_time,
        id: adsSelected[slot][i].ids,
        intervals: adsSelected[slot][i].intervals,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/upload-iterations`,
        jsonData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.success) {
      } else {
        throw new Error(response.data.message || "Failed to upload iterations");
      }
    } catch (error) {
      console.error("Error uploading iterations:", error);
      toast.error("Failed to upload Iterations: " + error.message);
    }
  };

  useEffect(() => {
    const timers = {};

    Object.keys(adsSelected).forEach((slotKey) => {
      const slot = parseInt(slotKey, 10);
      const adsInSlot = adsSelected[slot];
      const currentIndex = currentAdIndexes[slot];

      if (!adsInSlot || adsInSlot.length === 0 || currentIndex < 0) return;

      let nextIndex = currentIndex;

      const updateSlot = () => {
        // Update iterations if current ad is valid
        if (
          currentIndex < adsInSlot.length &&
          adsInSlot[currentIndex]?.iterations > 0
        ) {
          updateIterations(slot, currentIndex);
        }

        // Find next valid index with iterations > 0
        nextIndex = (currentIndex + 1) % adsInSlot.length;

        if (adsInSlot[nextIndex]?.iterations <= 0) {
          const originalIndex = nextIndex;
          while (
            adsInSlot[nextIndex]?.iterations <= 0 &&
            nextIndex !== currentIndex
          ) {
            nextIndex = (nextIndex + 1) % adsInSlot.length;
            if (nextIndex === originalIndex) break;
          }
        }

        // Prevent infinite loop if no valid ad is found
        if (adsInSlot[nextIndex]?.iterations <= 0) return;

        // Update index state
        setCurrentAdIndexes((prev) => ({
          ...prev,
          [slot]: nextIndex,
        }));
      };

      const interval =
        adsInSlot[currentIndex]?.iterations > 0
          ? adsInSlot[currentIndex]?.intervals
          : 1000;

      timers[slot] = setTimeout(updateSlot, interval);
    });

    return () => {
      // Clear all timers on cleanup
      Object.values(timers).forEach(clearTimeout);
    };
  }, [
    JSON.stringify(currentAdIndexes),
    JSON.stringify(
      Object.fromEntries(
        Object.entries(adsSelected).map(([slot, ads]) => [
          slot,
          ads.map((ad) => ad.iterations).join(","),
        ])
      )
    ),
  ]);

  return (
    <div>
      <Header pageType="ArenaUserDashboard" />

      <div className={styles.container}>
        {/* Text Ad Section */}
        <TextAds
          adsSelected={adsSelected}
          currentAdIndexes={currentAdIndexes}
          selectedAd={selectedAd}
          handleClicks={handleClicks}
          preview={preview}
          slot={1}
        />

        <div className={styles.ArenaContent}>
          <div className={styles.main}>
            <div className={`${styles.dashboardLeft} ${styles.animateFadeIn}`}>
              <div className={styles.map}>
                <AddressForm />
              </div>
              {userData && (
                <div className={styles.userInfo}>
                  <h5>Filter By</h5>
                  <div className={styles.userActions}>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className={styles.actionButton}
                        onClick={toggleMyBookings}
                        style={{
                          backgroundColor: showMyBookings ? "#0071bc" : "white",
                          border: showMyBookings
                            ? "solid 1px #0071bc"
                            : "solid 1px black",
                        }}
                      >
                        ✓
                      </button>
                      <span className={styles.buttonText}>My Bookings</span>
                    </div>

                    <div className={styles.cityDropdownContainer}>
                      <select
                        value={userCity}
                        onChange={handleCityChange}
                        className={styles.cityDropdown}
                      >
                        <option value="">Select a city</option>
                        {availableCities
                          .filter((city) => city)
                          .map((city) => (
                            <option key={city} value={city}>
                              {city}
                            </option>
                          ))}
                      </select>

                      {/* <div className={styles.dropdownIcon}>🌍</div> */}
                      <div className={styles.dropdownArrow}>▼</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="block md:hidden">
              <ImageVideoAds
                adsSelected={adsSelected}
                currentAdIndexes={currentAdIndexes}
                preview={preview}
                handleClicks={handleClicks}
                selectedAd={selectedAd}
                slot1={2}
                slot2={3}
              />
            </div>
          </div>

          <div className={`${styles.dashboardRight} ${styles.animateFadeIn}`}>
            <div className={styles.headerArena}>
              <h3
                key={
                  !selectedArena
                    ? "arenas"
                    : !selectedSport
                    ? "sports"
                    : !selectedFacility
                    ? "facilities"
                    : !selectedSlots
                    ? "slots"
                    : ""
                }
                className={styles.fadeSlide} // Assuming fadeSlide is in your CSS module
              >
                {!selectedArena
                  ? "Arenas"
                  : !selectedSport
                  ? "Sports"
                  : !selectedFacility
                  ? "Facilities"
                  : !selectedSlots
                  ? "Slot Selection"
                  : ""}
              </h3>
              {/* <div className={styles.userName}>
              <img src={ProfilePic} className={styles.profilepic1} alt="pic" />

              <h5>
                {localStorage.getItem("userName")}{" "}
                <div className={styles.userLocation}>
                  <MapPin size={14} />
                  <p>
                    {typeof userData?.location === "string" &&
                    userData.location.trim()
                      ? userData.location
                      : "Islamabad"}
                  </p>
                </div>
              </h5>
            </div> */}
              {(selectedArena ||
                selectedSport ||
                selectedFacility ||
                selectedSlots ||
                bookingType) && (
                <button className={styles.backButton} onClick={handleBack}>
                  ← Back
                </button>
              )}
            </div>
            {showNotifications && (
              <div
                className={styles.notificationsPanel}
                ref={notificationsPanelRef}
              >
                <h3>Notifications</h3>
                {notifications.length === 0 ? (
                  <p className={styles.noNotifications}>No new notifications</p>
                ) : (
                  notifications.map((notification) => (
                    <div key={notification.id} className={styles.notification}>
                      <div className={styles.notificationHeader}>
                        {notification.type === "friendRequest" && (
                          <User size={16} />
                        )}
                        {notification.type === "requestAccepted" && (
                          <Clock size={16} />
                        )}
                        {notification.type === "arenaApproved" && (
                          <MapPin size={16} />
                        )}
                        <span className={styles.notificationTime}>
                          {formatTimestamp(notification.timestamp)}
                        </span>
                        <button
                          className={styles.clearNotificationButton}
                          onClick={() =>
                            handleClearNotification(notification.id)
                          }
                        >
                          <X size={14} />
                        </button>
                      </div>
                      {notification.type === "friendRequest" && (
                        <>
                          <p className={styles.notificationTitle}>
                            <span
                              onClick={() =>
                                handleViewUserProfile(notification.sender)
                              }
                            >
                              {notification.sender.name}
                            </span>{" "}
                            sent you a friend request
                          </p>
                          <p className={styles.notificationMessage}>
                            {notification.message}
                          </p>
                          <div className={styles.matchDetails}>
                            <p>
                              <Clock size={14} />{" "}
                              {notification.matchDetails.date}{" "}
                              {notification.matchDetails.time}
                            </p>
                            <p>
                              <LocationIcon size={14} />{" "}
                              {notification.matchDetails.arena}
                            </p>
                            <p>{notification.matchDetails.sport}</p>
                          </div>
                          {!notification.status && (
                            <div className={styles.notificationActions}>
                              <button
                                onClick={() =>
                                  handleAcceptRequest(notification.id)
                                }
                              >
                                Accept
                              </button>
                              <button
                                onClick={() =>
                                  handleRejectRequest(notification.id)
                                }
                              >
                                Reject
                              </button>
                            </div>
                          )}
                          {notification.status && (
                            <p className={styles.notificationStatus}>
                              {notification.status === "accepted"
                                ? "Accepted"
                                : "Rejected"}
                            </p>
                          )}
                        </>
                      )}
                      {notification.type === "requestAccepted" && (
                        <>
                          <p className={styles.notificationTitle}>
                            {notification.accepter.name} accepted your play
                            request!
                          </p>
                          <div className={styles.matchDetails}>
                            <p>
                              <Clock size={14} />{" "}
                              {notification.matchDetails.date}{" "}
                              {notification.matchDetails.time}
                            </p>
                            <p>
                              <LocationIcon size={14} />{" "}
                              {notification.matchDetails.arena}
                            </p>
                            <p>{notification.matchDetails.sport}</p>
                          </div>
                        </>
                      )}
                      {notification.type === "arenaApproved" && (
                        <p className={styles.notificationTitle}>
                          Your arena "{notification.arenaName}" has been
                          approved!
                        </p>
                      )}
                      <ChevronRight
                        size={16}
                        className={styles.notificationArrow}
                      />
                    </div>
                  ))
                )}
              </div>
            )}

            {showUserProfile && selectedUser && (
              <UserProfile
                user={selectedUser}
                onClose={handleCloseUserProfile}
              />
            )}

            {showMyBookings ? (
              <MyBookings
                bookings={myBookings}
                onSubmitReview={handleSubmitReview}
                onCancelBooking={handleCancelBooking}
              />
            ) : showArenaProfile ? (
              <ArenaProfile
                arena={selectedArena}
                onClose={handleCloseProfile}
              />
            ) : (
              <>
                {!selectedArena && (
                  <>
                    {" "}
                    <ArenaGrid
                      arenas={arenas}
                      onArenaSelect={handleArenaSelect}
                      onViewDetails={handleViewDetails}
                      userLocation={userCity}
                    />
                  </>
                )}

                {selectedArena && !selectedSport && !showArenaProfile && (
                  <>
                    {selectedArena.sports ? (
                      <SportSelection
                        arena={selectedArena}
                        onSportSelect={handleSportSelect}
                      />
                    ) : (
                      <div>Loading sports data...</div>
                    )}
                  </>
                )}

                {isLoading ? (
                  <div>Loading facilities...</div>
                ) : (
                  selectedSport &&
                  !selectedFacility && (
                    <FacilitySelection
                      sport={selectedSport}
                      facilities={facilities}
                      onFacilitySelect={setSelectedFacility}
                    />
                  )
                )}

                {selectedFacility && !selectedSlots && (
                  <SlotSelection
                    facility={selectedFacility}
                    onSlotSelect={handleSlotSelect}
                  />
                )}

                {selectedSlots && !bookingType && (
                  <BookingOptions
                    onBookingTypeSelect={handleBookingTypeSelect}
                    onReturnToDashboard={handleReturnToDashboard}
                    slotData={selectedSlots}
                    refreshBookings={fetchBookings}
                  />
                )}
              </>
            )}
          </div>
          <div className="hidden md:block">
            <ImageVideoAds
              adsSelected={adsSelected}
              currentAdIndexes={currentAdIndexes}
              preview={preview}
              handleClicks={handleClicks}
              selectedAd={selectedAd}
              slot1={2}
              slot2={3}
            />
          </div>
        </div>
      </div>

      {/* Confirmation Modal for Cancel Booking */}
      <ConfirmationModal
        isOpen={showConfirmModal}
        title="Cancel Booking"
        message={`Are you sure you want to cancel your booking at ${
          selectedBookingForCancel?.arenaName || "Unknown Arena"
        } on ${selectedBookingForCancel?.date || "Unknown Date"} at ${
          selectedBookingForCancel?.startTime || "Unknown Time"
        }?`}
        onConfirm={handleConfirmCancelBooking}
        onCancel={handleCloseModal}
        confirmText="Yes, Cancel"
        cancelText="Keep Booking"
        confirmButtonClass="bg-red-600 text-white hover:bg-red-700"
      />
    </div>
  );
};

export default ArenaUserDashboard;
